__turbopack_context__.v({
  "quiz": "Quiz-module__lQSpLa__quiz",
});
